import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ICustomPageSection } from '../../models';

interface IIFrameSection {
  section: ICustomPageSection;
}

export const IFrameSection: FC<IIFrameSection> = ({ section }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {section?.sections?.map(sec => {
        return (
          <div className={classes.iframeContainer}>
            <iframe title={`iframe-${sec.customPageSectionId}`} src={sec.iFrameSrc}></iframe>
          </div>
        );
      })}
    </div>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  iframeContainer: {
    position: 'relative',
    width: '100%',
    // 16:9 aspect ratio
    paddingTop: '56.25%',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    '& > iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  },
  container: {
    textAlign: 'center'
  }
}));
